var map = {
	"./Bartek_C.jpg": "d0d1",
	"./Bartek_K1.jpg": "63d2",
	"./Basia.jpg": "f495",
	"./Dagmara.jpg": "2486",
	"./Daniel_M.jpg": "cc10",
	"./Eliza.jpg": "b57a",
	"./Grzesiu.jpg": "ef1d",
	"./Jedrzej.jpg": "4cff",
	"./Julka.jpeg": "19cc",
	"./Karolina.jpg": "4f65",
	"./Klaudia_K.jpg": "f004",
	"./Kocurek.jpg": "a505",
	"./Kurz.jpeg": "ac9c",
	"./Marek.jpg": "21d4",
	"./Maria.jpg": "f17b",
	"./Marta_O.jpg": "250d",
	"./Mateusz.jpg": "31e6",
	"./Natalka.jpg": "c586",
	"./Ola_S.jpeg": "28d2",
	"./Oskar.jpg": "9269",
	"./Patryk.jpg": "f0eb",
	"./Piotr.jpg": "2f59",
	"./Szymon.jpg": "06b3",
	"./Wojtek_Ch.jpg": "c2bf",
	"./Wojtek_G.jpg": "2a68"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c09a";